export default __webpack_public_path__ + "78a36ed1d9d5c1e46cbf5dd5b5532bf3.png";